// Auth + users. Real sign-in flows are refused in the demo; the session runs on
// the unsigned demo token seeded by DemoEntry.

import type { UpdateUserRequest } from '../../types/auth.type';
import { buildFakeJwt, demoError, isFakeJwt } from '../core';
import { demoMe, orgUsers, updateOrgUser } from '../data';
import { bodyOf, ok, routes } from './helpers';

const NOT_AVAILABLE = 'Not available in demo';

function currentFakeToken(): string {
  try {
    const stored = globalThis.sessionStorage?.getItem('access_token') ?? null;
    if (stored && isFakeJwt(stored)) return stored;
  } catch {
    /* no storage: mint a fresh one */
  }
  return buildFakeJwt();
}

export const authRoutes = routes([
  ['post', '/user/login', () => demoError(400, NOT_AVAILABLE)],
  ['post', '/user/register', () => demoError(400, NOT_AVAILABLE)],
  ['post', '/user/forgot-password', () => demoError(400, NOT_AVAILABLE)],
  ['post', '/user/reset-password', () => demoError(400, NOT_AVAILABLE)],
  [
    'post',
    '/app_user/refresh_token',
    () => {
      const token = currentFakeToken();
      return ok({ access_token: token, refresh_token: token });
    },
  ],
  ['get', '/user/me', () => ok(demoMe())],
  ['get', '/user/:orgId', ({ params }) => ok(orgUsers(params.orgId))],
  [
    'put',
    '/user/:orgId/:userId',
    (ctx) => ok(updateOrgUser(ctx.params.orgId, ctx.params.userId, bodyOf<UpdateUserRequest>(ctx))),
  ],
]);
